export const ReadingTypes = {
  BloodPressure: 'Blood Pressure',
  BloodGlucose: 'Blood Glucose',
  Weight: 'Weight',
  SpO2: 'SpO2',
  Temperature: 'Temperature',
  SleepingMatActivity: 'Sleeping Mat',
  PeakFlow: 'Peak Flow',
};
